<app-layout></app-layout>
<app-layout></app-layout>
<div class="content">
   
    <div class="container-field">
        <mat-form-field appearance="fill" style="width: 25%;">
            <mat-label>Users List</mat-label>
            <mat-select #select [(ngModel)]="selectedOptions" multiple [formControl]="itemsControl" (selectionChange)="onChange($event)" >
              <input (keyup)="checkEmpty($event)" (keydown)="onSearch(searchControl.value)" style="height: 40px;width: 100%; margin-bottom: 10px;" type="text" placeholder="Search..." matInput [formControl]="searchControl" >
             
              <mat-option *ngFor="let item of primaryList" [value]="item" (click)="onOptionClick($event, item)">
                    {{ getDisplayedValue(item) }}
                </mat-option>
            </mat-select>
        </mat-form-field>
      </div>
      
      
      
      <div class="container">
        <h2>Send Broadcast Message</h2>
        <form (ngSubmit)="sendMessage()">
              <div class="title-container">
                <label for="title">Users List</label>
                <div class="selected-values-container">
                    <input class="form-control selected-values-input" [value]="formattedSelectedValues" readonly>
                  </div>
                  
            </div>
              

            <div class="title-container">
                <label for="title">Title</label>
                <input type="text" class="form-control" id="title" [(ngModel)]="title" name="title" required placeholder="Enter Title">
            </div>
            <div class="form-group">
                <label for="message">Message:</label>
                <textarea class="form-control" id="message" rows="4" [(ngModel)]="message" name="message" required placeholder="Enter Message"></textarea>
            </div>
            <button type="button" class="btn btn-primary" style="background-color: #e5efe1;border: #e5efe1;color: black;" (click)="openModal()">Send Message</button>
        </form>
    </div>
    
    <ng-template #template>
        <div class="modal-header">
           
        </div>
        <div class="modal-body text-center delete-modal">
            <img src=".../../../../../assets/images/4753177.jpg" style="height: 150px;width: 200px;" alt="">
            <p>Are you sure you want to <br>Send the message?</p>
            <div class="modal-btn">
                <button class="btn btn-cancel" (click)="modalRef.hide()" style="color: black;">Cancel</button>
                <button class="btn btn-confirm" (click)="sendMessage()" style="background-color: #e5efe1;border: #e5efe1;color: black;">Confirm</button>
            </div>
        </div>
    </ng-template>
    
